/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Passwordconfirmationisrequired3Inputs */

const en_passwordconfirmationisrequired3 = /** @type {(inputs: Passwordconfirmationisrequired3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Password confirmation is required`)
};

const de_passwordconfirmationisrequired3 = /** @type {(inputs: Passwordconfirmationisrequired3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine Passwortbestätigung ist erforderlich.`)
};

/**
* | output |
* | --- |
* | "Password confirmation is required" |
*
* @param {Passwordconfirmationisrequired3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const passwordconfirmationisrequired3 = /** @type {((inputs?: Passwordconfirmationisrequired3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Passwordconfirmationisrequired3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_passwordconfirmationisrequired3(inputs)
	return de_passwordconfirmationisrequired3(inputs)
});
export { passwordconfirmationisrequired3 as "passwordConfirmationIsRequired" }